import { FC } from "react"

import { LeftOutlined } from "@ant-design/icons"
import { Card, Descriptions, Empty, Flex, Skeleton, Space } from "antd"
import { NavLink, useNavigate, useParams } from "react-router-dom"

import classes from "@/_styles/cardById.module.scss"
import variables from "@/_styles/variables.module.scss"
import { ColorifiedButton } from "@/components/_Shared/Button/ColorifiedButton"
import { Resource, Scope } from "@/constants/permission"

import { useAuthoritiesByIdQuery } from "@/hook/Authorities/useAuthoritiesPageQuery"
import { usePermission } from "@/hook/usePermission"

import { paths } from "@/router/paths"

import { dateTimeFormat, formatDate } from "@/utils/formatDate"

const { Item } = Descriptions

const AuthoritiesById: FC = () => {
  const { id } = useParams<{ id?: string }>()
  const navigate = useNavigate()
  const { hasPermission } = usePermission()

  const { data, isLoading, isError } = useAuthoritiesByIdQuery(Number(id))

  const onBackHandler = () => {
    navigate(-1)
  }

  if (isError) {
    return <Empty description="Внутренняя доверенность не найдена" />
  }

  return (
    <Skeleton loading={isLoading}>
      {data && (
        <Card className={classes["card"]}>
          <Space direction="vertical" className={classes["wrapper"]}>
            <Descriptions
              title={
                <div className={classes["header"]}>
                  <Flex align="center" gap="20px">
                    <ColorifiedButton
                      type="primary"
                      shape="circle"
                      size="small"
                      icon={<LeftOutlined />}
                      onClick={onBackHandler}
                    />
                    <span>
                      Внутренняя доверенность {data.response.number}
                    </span>
                  </Flex>
                </div>
              }
              layout="vertical"
              column={5}
              className={classes["descriptions"]}
              labelStyle={{
                fontWeight: 600,
                color: variables.tableSubTitleColor,
                marginBottom: "-30px"
              }}
              contentStyle={{
                paddingBottom: "15px"
              }}
            >
              <Item label="Дата выдачи">{formatDate(data.response.date, dateTimeFormat)}</Item>
              <Item label="Номер доверенности">{data.response.number}</Item>
              <Item label="Номер заказа">
                <NavLink 
                  key={"orderNumber" + data.response.orderAuthorities.orderId} 
                  to={
                    hasPermission(Resource.DispatcherOrders, Scope.Menu)? 
                    paths.dispatcherOrderById(data.response.orderAuthorities.orderId):paths.orderById(data.response.orderAuthorities.orderId)
                  }
                >
                  {data.response.orderAuthorities.orderNumber}
                </NavLink>
              </Item>
              <Item label="ФИО">
                <NavLink 
                  key={"driver" + data.response.driver.id} 
                  to={paths.driverById(data.response.driver.id)}
                >
                  {data.response.driver.fullName}
                </NavLink>
              </Item>
              <Item label="Контрагент">{data.response.orderAuthorities.customerName}</Item>
              <Item label="Поставщик">{data.response.provider.name}</Item>
              <Item label="Выдал">
                {data.response?.issuedName ?? "-"}
              </Item>
            </Descriptions>
          </Space>
        </Card>
      )}
    </Skeleton>
  )
}

export default AuthoritiesById
